export const environment = {
  production :true,
  apiUrl:  'https://backend.adora.com.tn'
  //apiUrl: 'http://192.168.100.8:5000'
}

